export class AppCheckbox extends HTMLElement {
  private originalContent: string = "";

  constructor() {
    super();
  }

  connectedCallback() {
    // Guardamos el contenido HTML interno provisto por el usuario
    // antes de reescribir el innerHTML con la plantilla del componente.
    if (!this.originalContent) {
      this.originalContent = this.innerHTML.trim();
    }
    this.render();
  }

  static get observedAttributes() {
    return ["formControlName", "input-id"];
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string) {
    if (oldValue !== newValue && this.originalContent) {
      this.render();
    }
  }

  render() {
    const controlName = this.getAttribute("formControlName") || "";
    // Si no nos pasan un id, generamos uno temporal para el "for" del label
    const inputId =
      this.getAttribute("input-id") ||
      `chk-${controlName || Math.random().toString(36).substr(2, 9)}`;

    this.innerHTML = `
            <div class="flex items-center space-x-1.5 md:space-x-3 transition-colors duration-200">
                <input ${controlName ? `formControlName="${controlName}"` : ""} id="${inputId}" type="checkbox" class="w-3 h-3 md:w-5 md:h-5 accent-white rounded cursor-pointer shrink-0" />
                <label for="${inputId}" class="text-xs md:text-sm text-white font-normal select-none cursor-pointer">
                    ${this.originalContent}
                </label>
            </div>
            ${controlName ? `<span formErrorFor="${controlName}" class="text-red-600 text-xs font-medium block min-h-[1.25rem] px-1 transition-all duration-150"></span>` : ""}
        `;
  }
}

if (typeof window !== "undefined") {
  customElements.define("app-checkbox", AppCheckbox);
}
